import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import Register from '../../../containers/Register/Register'

import './CreateAccountModal.scss'

const CreateAccountModal = ({ isOpen, toggle }) => {
  // Generate unique IDs for accessibility
  const modalTitleId = 'create-account-modal-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      id="createAccountModal"
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="sr-only">
          <FormattedMessage id="global.label.createAccount" defaultMessage="Create Account" />
        </h2>
        <Register isModal />
      </ModalBody>
    </Modal>
  )
}

CreateAccountModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default CreateAccountModal
